import { apiAction } from '../apiAction';

import { fetchGenericSourceDataTypes } from './types';
import * as api from './api';

export const fetchGenericSourceData = apiAction({
  types: fetchGenericSourceDataTypes,
  apiAction: api.fetchGenericSourceData,
});
